import type { TaskStatus } from './enums'

export interface WeekScopedTask {
  readonly status: TaskStatus
  /** Semana em que a tarefa foi lançada (`2026-W41`). */
  readonly semana_lancamento: string
  /** Semana em que fechou (realizada ou cancelada); nula enquanto aberta. */
  readonly semana_conclusao: string | null
}

/** Aberta = ainda pede trabalho (pendente ou em processo). */
export function isOpen(status: TaskStatus): boolean {
  return status === 'pendente' || status === 'em_processo'
}

/**
 * A tarefa aparece na semana `week`? (regra do Supply — ADR 0002)
 *
 * Aparece da semana em que foi lançada até a semana em que fechou. Aberta,
 * continua aparecendo em todas as semanas seguintes ("em aberto desde a semana
 * N"). Assim cada semana passada fica estável: a W42 continua mostrando o que
 * estava em jogo na W42, mesmo depois que a tarefa fechou na W43.
 */
export function isVisibleInWeek(task: WeekScopedTask, week: string): boolean {
  if (week < task.semana_lancamento) return false
  if (isOpen(task.status)) return true
  const closed = task.semana_conclusao ?? task.semana_lancamento
  return week <= closed
}

/**
 * Regra do protótipo HTML: fechada aparece só na semana de lançamento.
 * Mantida para comparação e caso o time prefira o comportamento antigo.
 */
export function isVisibleInWeekLegacy(task: WeekScopedTask, week: string): boolean {
  if (task.semana_lancamento === week) return true
  if (week < task.semana_lancamento) return false
  return isOpen(task.status)
}

/** Veio de uma semana anterior e continua em aberto ("↪ em aberto desde a semana N"). */
export function isCarriedOver(task: WeekScopedTask, week: string): boolean {
  return task.semana_lancamento < week && isOpen(task.status)
}
